import request from '@/router/axios'

const base = '/api/produce/arrival-analysis'

/** 到站车厢数趋势（折线）：title、trainCount、weightSum，trainCount 为车厢数汇总 */
export const fetchArrivalTrend = (data) =>
  request({ url: `${base}/arrivalTrend`, method: 'post', data })

/** 煤種到站量對比（柱狀）：title、data 為噸位 */
export const fetchCargoBar = (data) =>
  request({ url: `${base}/arrivalModeDistribute`, method: 'post', data })

/** 到站明細分頁 */
export const fetchArrivalDetailPage = (data) =>
  request({ url: `${base}/arrivalDetailPage`, method: 'post', data })

/** 底部汇总：totalTrains、totalWeight、cargoPie[{name,weight,percent}]，totalTrains 为车厢数汇总 */
export const fetchArrivalSummary = (data) =>
  request({ url: `${base}/arrivalSummary`, method: 'post', data })

/** 煤种远程检索（与表格列 dicUrl 一致：/produce/vardict/select/distinct/pycode?cargoName=） */
export const searchVardictPycode = (cargoName) =>
  request({
    url: '/api/produce/vardict/select/distinct/pycode',
    method: 'get',
    params: {
      cargoName: cargoName != null ? String(cargoName) : '',
      // 后端 DTO 为 varName，与 cargoName 同传以保证模糊检索生效
      varName: cargoName != null ? String(cargoName) : '',
      page: 1,
      size: 50
    }
  })
